export const APP_RESET_STATE = 'APP_RESET_STATE'



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/app.js